import { Box } from '@mui/material';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Toast from '../../components/Toast/Toast';
import { UnsavedChangesBanner } from '../../components/UnsavedChangesBanner/UnsavedChangesBanner';
import { LANG_TEXT } from '../../constants/language';
import { usePreorderRules } from '../../context/PreorderRulesContext/PreorderRulesContext';
import AstrolabReminder from './components/AstrolabReminders/AstrolabReminder';
import ClientEmailContacting from './components/ClientEmailContacting/ClientEmailContacting';
import PreorderRule from './components/PreorderRules/PreorderRule';

export default function PreorderRulesPage() {
  const { t } = useTranslation();
  const {
    currentValues,
    hasUnsavedChanges,
    isSaving,
    isLoading,
    resetKey,
    handleSave,
    handleCancel,
    updatePreorderRule,
    updateClientEmailContacting,
    updateAstrolabReminder,
    isFormValid,
  } = usePreorderRules();

  const toast = useRef<{ type: 'error' | 'success'; content: string }>({
    type: 'success',
    content: '',
  });
  const [openToast, setOpenToast] = useState(false);

  const onSave = async () => {
    try {
      await handleSave();
      toast.current = {
        content: t(LANG_TEXT.UPDATE_SUCCESS_MESSAGE),
        type: 'success',
      };
      setOpenToast(true);
    } catch (error: any) {
      toast.current = {
        content: error?.message || t(LANG_TEXT.UPDATE_FAILED_MESSAGE),
        type: 'error',
      };
      setOpenToast(true);
    }
  };

  if (isLoading) {
    return null;
  }

  return (
    <>
      <Toast content={toast.current?.content} variant={toast.current?.type} open={openToast} onClose={() => setOpenToast(false)} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: 2, position: 'relative', pb: hasUnsavedChanges ? 10 : 2 }}>
        <PreorderRule onChange={updatePreorderRule} initialValues={currentValues.preorderRule} resetKey={resetKey} />
        <ClientEmailContacting onChange={updateClientEmailContacting} initialValues={currentValues.clientEmailContacting} resetKey={resetKey} />
        <AstrolabReminder onChange={updateAstrolabReminder} initialValues={currentValues.astrolabReminder} resetKey={resetKey} />
        {hasUnsavedChanges && <UnsavedChangesBanner onSave={onSave} onCancel={handleCancel} isSaving={isSaving} disabled={!isFormValid} />}
      </Box>
    </>
  );
}
